export default "__VITE_ASSET__BYhNy3yp__"